<template>
  <b-table
    responsive="sm"
    :fields="fields"
    :items="dataList"
    striped
    small
  >
    <template #cell(title)="data">
      <div class="d-flex align-items-center">
        <div class="mr-1">
          <b-button
            pill
            class="btn-icon"
            variant="flat-success"
            :to="'/app/projects/view/' + data.item.id"
            target="_blank"
          >
            <FeatherIcon icon="EyeIcon" />
          </b-button>
        </div>
        <div>
          <div>
            {{ data.item.title }}
          </div>
        </div>
      </div>
    </template>
    <template #cell(idate)="data">
      <div>
        {{ moment(data.item.idate).format('LL') }}
      </div>
    </template>
    <template #cell(project_status)="data">
      <div>
        {{ data.item.project_status }}
      </div>
    </template>
    <template #cell(username)="data">
      <div v-if="data.item.username">
        {{ data.item.username }}
      </div>
    </template>
  </b-table>
</template>
<script>
import { BTable, BButton } from 'bootstrap-vue'

export default {
  name: 'Projects',
  components: {
    BTable,
    BButton,
  },
  props: {
    dataList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Proje',
        },
        {
          key: 'idate',
          label: 'GÖRÜŞME TARİHİ',
        },
        {
          key: 'project_status',
          label: 'DURUM',
        },
        {
          key: 'username',
          label: 'TEMSİLCİ',
        },
      ],
    }
  },
}
</script>
